import React from "react";
import './TimeLine.css';

interface IPoint {
    value: number,
    label: string
}

interface ITimeLineProps{
    points: Array<IPoint>,
    selectedPoints: Array<IPoint>,
    noRound?: boolean
}

const getRoundedTop = (value: number)=>{
    return Math.floor(value / 17) * 17 + 'px'
}

export const TimeLine = ({points, selectedPoints, noRound}: ITimeLineProps)=>{
    return <div className={`timeLine`}>
        {points.map((point, index) => { // Added key prop here
            return <div key={`point-${index}`} className="timeLine_point timeLine_point--unselected" style={{top: noRound ? point.value : getRoundedTop(point.value)}}>{point.label}</div>
        })}
        {selectedPoints.map((point, index) => { // Added key prop here
            return <div key={`selectedPoint-${index}`} className="timeLine_point timeLine_point--selected" style={{top: noRound ? point.value : getRoundedTop(point.value)}}>{point.label}</div>
        })}
    </div>
}